import React from 'react';
import SetUpPresentational from './setup-presentational';

const SetUpFunctional = () => {
	return <SetUpPresentational />;
};

export default SetUpFunctional;
